import c from "./lib/createApi";

/**
 * dictionary
 */

const defaultUrl = "/v1/dictionary";

export default {
  getAll: c("GET", defaultUrl + "", true), // [dictionary - 1] category별 사전 전체 조회
  get: c("GET", defaultUrl + "/:id", true), // [dictionary - 2] id로 사전 조회
  tag: {
    get: c("GET", defaultUrl + "/tag/:id", true), // [dictionary - 3] tag id로 사전 조회  
  },
  put: c("PUT", defaultUrl + "/representative", true), // [dictionary - 4] 대표어 변경 요청
  getDictionaryByKey: c("GET", defaultUrl + "/key", true), // [dictionary - 5] uuid로 연결된 사전 조회  Link가 존재하지 않으면 tagId를 사용하여 default dictionary를 조회함.
  createOrModifyDictionary: c("POST", defaultUrl + "/create-modify-dictionary", true), // [dictionary - 6] 신규 사전 생성 (이미 생성된 사전이 있다면 유사어 추가)
  mergeDictionary: c("POST", defaultUrl + "/merge-dictionary", true), // [dictionary - 7] 사전 병합
  detailDictionary: c("GET", defaultUrl + "/detail-dictionary", true), // [dictionary - 8] 사전 상세보기
  editDictionary: c("PUT", defaultUrl + "/edit-dictionary", true), // [dictionary - 9] 사전 수정
  changeLinkKey: c("POST", defaultUrl + "/link-key", true), // [dictionary - 10] keyLink 데이터 update (존재하지 않으면 insert)
  createDictionary: c("POST", defaultUrl + "/create-dictionary", true), // [dictionary - 11] 사전 생성
  setDictionaryLinkForNewProtocol: c("POST", defaultUrl + "/set-dictionary-link", true), // [dictionary - 12] 프로토콜 생성 후 keyLink저장. 
  getDictionaryByRepresentativeName: c("GET", defaultUrl + "/representative-name", true), // [dictionary - 13] 대표어 이름을 사용하여 사전 조회
  getDictionaryKeyLinksByProcessId: c("GET", defaultUrl + "/get-dictionary-key-links", true), // [dictionary - 14] 공정도아이디로 keyLinks 조회(노드별 순서적용 목적)
  getDictionaryKeyLinkByProcessIdAndKey : c("GET", defaultUrl + "/get-dictionary-key-link", true), // [dictionary - 15] 단일 keyLinks 조회
  getReleaseDictionaryKeyLinksByReleaseProcessId: c("GET", defaultUrl + "/get-release-dictionary-key-links", true), // [dictionary - 16] 공정도아이디로 공개 keyLinks 조회(노드별 순서적용 목적)
  deleteDictionary: c("DELETE", defaultUrl + "/delete-dictionary", true), // [dictionary - 17] 사전 비활성화
};
